// 自定义轮播图
import React, {useState} from 'react';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Carousel } from 'antd';
import './lmCarousel.less';
import {Utils} from "../../../tools/utils";

// 组件：自定义轮播图
export const LmCarousel = props => {
  let Slider = null;// 轮播图的refs
  const initState = {
    activeIndex:0,
    list:props.list
  };
  const [state, setState] = useState(initState);
  // setState方法
  const $set = (curState) => {
    if (typeof curState !== 'object') return;
    setState(preState => ({...preState, ...curState}))
  };
  // 轮播图设置
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const onChange = index => {
    props.onChange && props.onChange(index);
  };
  const onClick = index => {
    props.onClick && props.onClick(index);
  };
  return (
    <div className="LmCarousel_div">
      <LeftOutlined
        className='left_icon'
        onClick={_=> {
          Slider && Slider.prev && Slider.prev();
        }} />
      <RightOutlined
        className="rigth_icon"
        onClick={_=> {
          Slider && Slider.next && Slider.next();
        }} />
      <Carousel
        { ... settings }
        ref={node=>{
          Slider = node
        }}
        autoplay={true}
        dots={true}
        afterChange={activeIndex => {
          $set({activeIndex});
          onChange(activeIndex)
        }}
      >
        {
          state.list && state.list.map((item,index) => {
           return (
             <div key={index} className="roll_div">
              <a
                className="lunbo_a_style"
                style={{backgroundImage: `url("${item.picturePath}")`,}}
                onClick={_=>{
                  onClick(index)
                    Utils.customTrack('MerchantHomeTopBannerClick', {
                        activity_rule_id: item.activityRuleId || '',
                        // activity_rule_name: item.ruleName || '', // 已确认不传
                        spu_id: item.spuId || '',
                        spu_name: item.spuName || '',
                    });
                }}
              />
             </div>
           )
          })
        }
      </Carousel>
      {/*底部指示器*/}
      <div className="pageination_div">
        <ul>
          {
            state.list && state.list.map((item,index) => (
              <li
                key={index}
                className={state.activeIndex === index ? 'active' : ''}
                onClick={_=> {
                  Slider && Slider.goTo && Slider.goTo(index);
                  $set({activeIndex: index});
                  Utils.customTrack('MerchantHomeTopBannerClick', {
                      activity_rule_id: item.activityRuleId || '',
                      // activity_rule_name: item.ruleName || '',
                      spu_id: item.spuId || '',
                      spu_name: item.spuName || '',
                  });
                }}
              >
                <span>{index + 1}</span>
              </li>
            ))
          }
        </ul>
      </div>
    </div>
  );
};

